import { MiddlewareState } from "@floating-ui/dom";
import { ISizeMiddlewareState } from "../interfaces/ISizeMiddlewareState";

export const applyFloatingHeightRestrictionForMobileDevices = (sizeState: MiddlewareState & ISizeMiddlewareState): void => {
    const mobileDropdownMaxHeight = 400;
    const newHeight = sizeState.availableHeight > mobileDropdownMaxHeight ? mobileDropdownMaxHeight : sizeState.availableHeight;
    sizeState.elements.floating.style.maxHeight = `${newHeight}px`;
};
